export const GET_POST_INFO = 'GET_POST_INFO' as const;
export const GET_POST_INFO_PENDING = 'GET_POST_INFO_PENDING' as const;
export const GET_POST_INFO_FULFILLED = 'GET_POST_INFO_FULFILLED' as const;
export const GET_POST_INFO_REJECTED = 'GET_POST_INFO_REJECTED' as const;
export const GET_POST_COMMENTS = 'GET_POST_COMMENTS' as const;
export const GET_POST_COMMENTS_PENDING = 'GET_POST_COMMENTS_PENDING' as const;
export const GET_POST_COMMENTS_FULFILLED = 'GET_POST_COMMENTS_FULFILLED' as const;
export const GET_POST_COMMENTS_REJECTED = 'GET_POST_COMMENTS_REJECTED' as const;
